import React, { FC } from 'react';
import { useViewport } from '../../context';
import { OneColumnLayout, TwoColumnLayout } from '../../components/layouts';
import { LiteCategories } from './Categories/LiteCategories/LiteCategories';
import { SideContent } from './Categories/LiteCategories/SideContent';
import { MobileCategories } from './MobileCategories/MobileCategories';

export interface CategoriesWrapperProps {}

export const CategoriesWrapper: FC<CategoriesWrapperProps> = () => {
  const { isMobile } = useViewport();

  if (isMobile) {
    return <OneColumnLayout content={<MobileCategories />} />;
  }

  return (
    <TwoColumnLayout
      mainContent={<LiteCategories />}
      sideContent={<SideContent />}
      mainContentSpan={6}
      sideCellStyle={{ maxWidth: '550px' }}
    />
  );
};
